<div class="form-image-wrapper">
    <img data-cy="form-image" [src]="image.image.url" class="image" />
</div>
